import axios from 'axios';
import { URL_LOGIN } from 'Helpers/urls';
import { removeItemFromStorage } from 'Utils/storage';
import { ErrorMessageModal } from 'Components/Common/Modal';
import { PAYPAL_SANDBOX_BASE_URL } from './path';

const {
  REACT_APP_API_BASE_URL: BASE_URL,
  REACT_APP_API_NCB_BASE_URL: NCB_BASE_URL,
  REACT_APP_API_FINANCIAL_BASE_URL: FINANCIAL_BASE_URL,
} = process.env;

axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => {
    /* Any status code that lie within the range of 2xx cause this function to trigger
     Do something with response data */
    return response;
  },
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      removeItemFromStorage('user');
      window.location.href = URL_LOGIN;
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    return Promise.reject(error);
  },
);

const handleError = (error) => {
  const { response } = error;
  if (response) {
    if (response.status === 500) ErrorMessageModal('Internal server Error!');
    else if (response.status === 403) ErrorMessageModal(response.data.message);
    else if (response.data && response.data.body && response.data.body.length) ErrorMessageModal(response.data.body[0].message);
  }
  throw error;
};

export const get = (url, params, config = {}) => {
  const baseUrl = url.includes(NCB_BASE_URL) || url.includes(FINANCIAL_BASE_URL) ? url : BASE_URL + url;
  return axios
    .get(baseUrl, { params, ...config })
    .then((response) => response.data)
    .catch((error) => handleError(error));
};

export const post = (url, payload, config = {}) => {
  const baseUrl = url.includes(NCB_BASE_URL) || url.includes(PAYPAL_SANDBOX_BASE_URL) ? url : BASE_URL + url;
  return axios
    .post(baseUrl, payload, config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return handleError(error);
    });
};

// Naming 'delet' is not a mistake
// 'delete' is reserved keyword we can not use.
export const delet = (url) =>
  axios
    .delete(BASE_URL + url)
    .then((response) => response.data)
    .catch((error) => handleError(error));

export const put = (url, payload) =>
  axios
    .put(BASE_URL + url, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => handleError(error));

export const patch = (url, payload) =>
  axios
    .patch(BASE_URL + url, payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => handleError(error));
